import { tns } from 'tiny-slider/src/tiny-slider';

class LogosSlider {
	constructor(el) {
		this.el = el;
		const logoCount = this.el.children.length;

		const logosSlider = tns({
			container: this.el,
			loop: true,
			slideBy: 1,
			freezable: false,
			responsive: {
				350: {
					items: Math.min(logoCount, 2)
				},
				500: {
					items: Math.min(logoCount, 3)
				},
				700: {
					items: Math.min(logoCount, 5)
				}

			},
			autoplay: true,
			autoplayTimeout: 1,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventActionWhenRunning: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 1800,
			controls: false,
			nav: false,
			gutter: 50
		});

		return logosSlider;
		
	}
}

export default LogosSlider;
